module.exports =
  base: 'sanmar'
  views:
    demo:
      design: '/sanmar/views/demo/design'
      customer:
        orders:
          base: '/sanmar/views/demo/customer/orders'
          detail: '/sanmar/views/demo/customer/orders/:orderId'
          approval: '/sanmar/views/demo/customer/orders/:orderId/approval'
      vendor:
        orders:
          base: '/sanmar/views/demo/vendor/orders'
          detail: '/sanmar/views/demo/vendor/orders/:orderId'
        invoices:
          base: '/sanmar/views/demo/vendor/manager'

  widget:
    base: '/sanmar/widget/base.js'
    demo: '/sanmar/widget/demo.html'
    test: '/sanmar/widget/test'
  data:
    design:
      base: '/sanmar/data/design/'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/sanmar.coffee